var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElderlyCareHomes = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 44,
  fill: "none",
  viewBox: "0 0 54 44"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M51.1 24.003a23.999 23.999 0 1 0-45.862 9.9h43.723a23.9 23.9 0 0 0 2.139-9.9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M3.701 33.902h46.8M1 33.902h1.5M51.701 33.902h1.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M11.676 38.668c0 .43 1.595.843 4.435 1.148s6.69.475 10.706.475 7.868-.171 10.707-.475c2.84-.305 4.435-.717 4.435-1.148s-1.595-.843-4.435-1.147-6.69-.475-10.707-.475c-4.015 0-7.867.17-10.706.475-2.84.304-4.435.717-4.435 1.147"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M48.041 32.332a1.76 1.76 0 0 0-1.757-1.757c-.28.002-.554.071-.801.202a2.326 2.326 0 0 0-3.082-1.164 3.5 3.5 0 0 0-6.646 1.428 1.755 1.755 0 1 0-1.183 3.049h11.714a1.68 1.68 0 0 0 1.755-1.758"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M20.721 6.578a1.905 1.905 0 0 0-1.901-1.904 1.9 1.9 0 0 0-.685.133 3.16 3.16 0 0 0-6.244 0 1.901 1.901 0 1 0-.685 3.674h7.614a1.904 1.904 0 0 0 1.901-1.903M38.12 18.572v-6.64a1.015 1.015 0 0 0-1.015-1.015h-2.842a1.016 1.016 0 0 0-1.015 1.015v2.422z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.37 38.27a.66.66 0 0 1-.66.66H15.673a.66.66 0 0 1-.66-.66V24.488L27.19 13.923l12.18 10.564z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M39.37 38.27a.66.66 0 0 1-.66.66H15.673a.66.66 0 0 1-.66-.66V24.488L27.19 13.923l12.18 10.564z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M13.829 24.924a1.826 1.826 0 0 1-1.183-3.218l13.362-11.571a1.82 1.82 0 0 1 2.367 0l13.366 11.57a1.827 1.827 0 1 1-2.368 2.783L27.192 13.923 15.012 24.49c-.33.281-.75.435-1.183.435M34.467 10.917h2.436v-1.42a1.015 1.015 0 0 0-1.015-1.016h-.406a1.016 1.016 0 0 0-1.015 1.016z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M34.467 10.917h2.436v-1.42a1.015 1.015 0 0 0-1.015-1.016h-.406a1.016 1.016 0 0 0-1.015 1.016z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M31.891 25.957h-2.474v-2.475a1.24 1.24 0 0 0-1.238-1.237h-1.98a1.237 1.237 0 0 0-1.237 1.237v2.475h-2.473a1.237 1.237 0 0 0-1.237 1.236v1.98a1.237 1.237 0 0 0 1.237 1.238h2.474v2.471a1.236 1.236 0 0 0 1.236 1.24h1.98a1.236 1.236 0 0 0 1.238-1.24V30.41h2.474a1.237 1.237 0 0 0 1.237-1.237v-1.98a1.24 1.24 0 0 0-1.237-1.236"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M31.891 25.957h-2.474v-2.475a1.24 1.24 0 0 0-1.238-1.237h-1.98a1.237 1.237 0 0 0-1.237 1.237v2.475h-2.473a1.237 1.237 0 0 0-1.237 1.236v1.98a1.237 1.237 0 0 0 1.237 1.238h2.474v2.471a1.236 1.236 0 0 0 1.236 1.24h1.98a1.236 1.236 0 0 0 1.238-1.24V30.41h2.474a1.237 1.237 0 0 0 1.237-1.237v-1.98a1.24 1.24 0 0 0-1.237-1.236"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M13.829 24.924a1.826 1.826 0 0 1-1.183-3.218l13.362-11.571a1.82 1.82 0 0 1 2.367 0l13.366 11.57a1.827 1.827 0 1 1-2.368 2.783L27.192 13.923 15.012 24.49c-.33.281-.75.435-1.183.435"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M19.613 40.927a1.744 1.744 0 0 0-2.559-1.556 2.327 2.327 0 0 0-3.086-1.163 3.499 3.499 0 0 0-6.644 1.428 1.755 1.755 0 1 0-1.183 3.047h11.717a1.68 1.68 0 0 0 1.755-1.756"
})));
export { SvgElderlyCareHomes as ReactComponent };